export const UserGuideApiDto = Symbol.for('UserGuideApiDto');
